import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { Api } from 'store/api';
import { toast } from 'react-hot-toast';
import React from 'react';

interface UpdateUsernameModalProps {
  open: boolean;
  onClose: () => void;
}

export function UpdateUsernameModal({ open, onClose }: UpdateUsernameModalProps) {
  const [username, setUsername] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const responseBody = await Api.updateUsername(username);
      if (responseBody.status === 'OK') {
        toast.success('Username updated successfully');
      } else {
        throw responseBody
      }
      onClose();
    } catch (error) {
      console.log(error)
      toast.error('Failed to update username');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => { 
        toast.error("You must enter a username to access this page") 
    }}>
      <DialogTitle>Enter your artist name</DialogTitle>
      <DialogContent>
        <p> This will be displayed publicly when you use/share community styles or songs</p>
        <TextField
          autoFocus
          margin="dense"
          label="New Username"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={onClose}>Cancel</Button> */}
        <Button 
          onClick={handleSubmit} 
          disabled={!username || isSubmitting}
          variant="contained"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}